'use client';

import { ReactElement, useEffect } from 'react';
import { useLicenseStore } from './licenseStore';
import { LicenseCode, SanityLicense } from './types/licenses';

type CurrentLicenseHandlerProps = {
  licenseCode: LicenseCode;
  license: Pick<SanityLicense, 'wareNumbers' | 'categories'>;
};

// Ensures that the current license is set in the store when this component is mounted. This ensures that the subsequent components always know that currentLicense is correct.
export const CurrentLicenseHandler = ({ licenseCode, license }: CurrentLicenseHandlerProps): ReactElement => {
  const { setCurrentLicense, isHydrated } = useLicenseStore(s => ({
    setCurrentLicense: s.setCurrentLicense,
    isHydrated: s.isHydrated,
  }));

  useEffect(() => {
    if (!isHydrated) return;
    setCurrentLicense(licenseCode, license);
  }, [isHydrated, licenseCode, license, setCurrentLicense]);

  return <></>;
};
